
import React from "react";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Filter, RefreshCw } from "lucide-react";

const CompanyFilter = ({ 
  selectedCompany, 
  onCompanyChange, 
  companies, 
  onRefresh, 
  isLoading 
}) => {

  // Find the selected company name for display
  const selectedCompanyObj = companies.find(c => c.id === selectedCompany);
  const selectedCompanyName = selectedCompanyObj?.name;

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Filter className="h-5 w-5" />
            Select Company
          </CardTitle>
          <div className="flex items-center gap-4">
            <Select value={selectedCompany || ""} onValueChange={onCompanyChange}>
              <SelectTrigger className="w-64">
                <SelectValue placeholder="Choose a company to view exams">
                  {selectedCompanyName || "Choose a company to view exams"}
                </SelectValue>
              </SelectTrigger>
              <SelectContent className="bg-white border shadow-lg z-50">
                {companies && companies.length > 0 ? (
                  companies.map((company) => (
                    <SelectItem key={company.id} value={company.id}>
                      {company.name}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem value="no-companies" disabled>
                    No companies found
                  </SelectItem>
                )}
              </SelectContent>
            </Select>
            <Button
              variant="outline"
              size="sm"
              onClick={onRefresh}
              disabled={isLoading}
              className="flex items-center gap-2"
            >
              <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
              Refresh
            </Button>
          </div>
        </div>
      </CardHeader>
    </Card>
  );
};

export default CompanyFilter;
